import React, { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";

const ProjectsChromeContext = createContext(null);

// Keep the routed page as the sole owner of lens state and actions. Only its
// navigation is promoted; weekly counts and controls stay in normal flow.
export function ProjectsChromeProvider({ children }) {
  const [host, setHost] = useState(null);
  return <ProjectsChromeContext.Provider value={{ host, setHost }}>{children}</ProjectsChromeContext.Provider>;
}

export function ProjectsNavigationHost() {
  const chrome = useContext(ProjectsChromeContext);
  return <div ref={chrome.setHost} data-testid="projects-navigation-host" />;
}

export function ProjectsNavigation({ children }) {
  const chrome = useContext(ProjectsChromeContext);
  const navigation = <div data-testid="projects-subnav-band">{children}</div>;
  // Isolated/embedded collection renders have no shell host.
  return chrome ? (chrome.host ? createPortal(navigation, chrome.host) : null) : navigation;
}
